import * as apicall from "../components/Apicall";

// The bell also shows the per-person notifications (ezp_notifications) the Procurement module writes:
// a supplier accepted, a quotation arrived ... The vendor bell (vendor_notifications) is untouched.
//
// Only Procurement's own keywords ("proc...") are shown for now: the same table holds years of
// mobile-app alerts (bookings, chat) that were never on the web bell, and they stay out of it.
// A row's id is encrypted afresh in every response, so it is only ever used to act on that row.

export const EZP_PREFIX = "ezp:";
export const isEzpId = (id) => typeof id === "string" && id.startsWith(EZP_PREFIX);
const rawId = (id) => id.slice(EZP_PREFIX.length);
const isProc = (n) => typeof n.redirection === "string" && n.redirection.startsWith("proc");

// Where a notification leads. A keyword is one path, or { buyer, supplier } when both sides get it
// (the buyer's bell and the supplier portal's bell each ask for their own side).
const TARGETS = {
  procSuppliers: "/proc/suppliers",
  procInvitation: "/supplier/buyers",
  procRfq: { buyer: "/proc/rfqs", supplier: "/supplier/rfqs" },
  procMessage: { buyer: "/proc/messages", supplier: "/supplier/messages" },
  procOrder: { buyer: "/proc/orders", supplier: "/supplier/orders" },
};
export const notificationTarget = (n, side = "buyer") => {
  const t = n && TARGETS[n.redirection];
  return (t && (typeof t === "string" ? t : t[side])) || null;
};

export async function fetchEzpNotifications() {
  try {
    const res = await apicall.get("ezpNotifications");
    return (Array.isArray(res?.data) ? res.data : []).filter(isProc).map((n) => ({
      id: EZP_PREFIX + n.id,
      title: n.title,
      message: n.message,
      is_read: n.is_read ? 1 : 0,
      created: n.created,
      redirection: n.redirection,
      source: "ezp",
    }));
  } catch (err) {
    return []; // the bell must never break because of this source
  }
}

export const markEzpRead = (id) => apicall.get(`ezpNotification_readStatus/${rawId(id)}`);
export const deleteEzp = (id) => apicall.get(`ezpNotification_delete/${rawId(id)}`);

// Newest first across both sources.
export const mergeNotifications = (...lists) => lists.flat().sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());
